const topics = [
  { tag: '韩漫下载', views: '128.6万', hot: true },
  { tag: '韩漫APK', views: '96.3万', hot: true },
  { tag: '离线韩漫', views: '84.7万', hot: true },
  { tag: '韩漫免费', views: '73.2万', hot: false },
  { tag: '韩漫推荐', views: '65.8万', hot: false },
  { tag: '热门连载', views: '58.1万', hot: true },
  { tag: '完结韩漫', views: '49.5万', hot: false },
  { tag: '韩漫汉化', views: '42.3万', hot: false },
  { tag: '新番速递', views: '37.9万', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            看看大家都在关注哪些韩漫相关话题，紧跟热度不掉队
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((item) => (
            <a
              key={item.tag}
              href="#topics"
              className="group relative inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 hover:bg-primary-100/70 border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              {item.hot && (
                <span className="absolute -top-1.5 -right-1.5 w-5 h-5 flex items-center justify-center">
                  <span className="absolute w-full h-full rounded-full bg-accent-500 animate-ping opacity-40"></span>
                  <span className="relative w-2.5 h-2.5 rounded-full bg-accent-500"></span>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                #{item.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {item.views}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}